/**Dependencies */
import React, { useEffect, useState } from "react";
import useForm from "../hooks/useForm";
import { Link, useNavigate } from "react-router-dom";
import { FreeMode, Navigation, Thumbs, Autoplay } from "swiper/modules";

/**Components*/
import { Col, Row } from "react-bootstrap";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { FaCheck, FaChild, FaMale, FaRegCheckCircle } from "react-icons/fa";
import {
  Currency,
  FormatCancellationPolicies,
  FormatDate,
  calculateBookingDates,
  fetchMarkup,
  totalPrices,
} from "../helpers";

/**Styles */
import "../styles/hotel.scss";

/**Images */
import { IoCalendarNumberOutline, IoStarSharp } from "react-icons/io5";
import { useLocation } from "react-router-dom";
import { getHotelAvailability, getHotels } from "../services/searchService";
import { Swiper, SwiperSlide } from "swiper/react";
import seguroViajero from "../images/seguro-viajero.png";
import { SearchEngine } from "../components/SearchEngine";
import { MdOutlineCancel, MdOutlineFastfood } from "react-icons/md";
import { ModalHabs } from "../components/ModalHabs";
import { AiOutlineDollar } from "react-icons/ai";
import { FaChildren } from "react-icons/fa6";
import { Loader } from "../components/Loader";
import Swal from "sweetalert2";
import { FormContact } from "../components/FormContact";
import { elementoPorSeccion } from "../services/adminProductService";
import bannerContacto from "../images/Banner de contacto.png";
import imgPreview from "../images/image-preview.jpg";
import { CheckOutCart } from "../components/CheckOutCart";
import { getActivePDP } from "../services/checkoutService";

export const Hotel = ({ idElemento = 2 }) => {
  const location = useLocation();
  const { checkIn, checkOut } = calculateBookingDates();
  // Función para parsear los parámetros de la URL
  const parseQueryParams = (query) => {
    return Object.fromEntries(new URLSearchParams(query));
  };
  const queryParams = parseQueryParams(location.search);
  const [hideSearchDestination, setHideSearchDestination] = useState("none");
  const [selectedDates, setSelectedDates] = useState([]);
  const [buttonText, setButtonText] = useState("Contácta con tu asesor");
  const [hidePaxSelection, setHidePaxSelection] = useState("none");
  let requestData = [];
  const navigate = useNavigate();
  const [totalRooms, setTotalRooms] = useState([]);
  const [rooms, setRooms] = useState([]);
  const [nameDestination, setNameDestination] = useState("");
  const [loading, setLoading] = useState(true); // Indicador de carga
  const [hotels, setHotels] = useState([]); // Estado para los hoteles
  const [rates, setRates] = useState([]); // Estado para los hoteles
  const [showModal, setShowModal] = useState(false);
  const [showModalHab, setShowModalHab] = useState(false);
  const [activeRoomId, setActiveRoomId] = useState(null);
  const [nights, setNights] = useState(0);
  const [timeNights, setTimeNights] = useState();
  const [imgsBanners, setImgsBanners] = useState([]);
  const [markup, setMarkup] = useState("");
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const [showAlert, setShowAlert] = useState(false);
  const [pdp, setPdp] = useState();
  const [arrSessionUrl] = useState([location.pathname, location.search]);
  const [arrSession, setArrSession] = useState(
    JSON.parse(sessionStorage.getItem("datosReserva"))
  );
  let img;
  useEffect(() => {
    const fetchMarkupPanel = async () => {
      try {
        const markupData = await fetchMarkup();
        setMarkup(markupData.markup);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchMarkupPanel();
  }, []);

  useEffect(() => {
    const pasarelaActiva = async () => {
      try {
        const pasarela = await getPdp();
        setPdp(pasarela);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    pasarelaActiva();
  }, []);
  const getPdp = async () => {
    try {
      const response = await getActivePDP();
      return response;
    } catch (error) {
      console.error("Error fetching rates:", error);
      return [];
    }
  };
  /**
   * Función para manejar el envío del formulario de contacto,
   * esta función se encarga de tomar los datos del formulario,
   * llamar al servicio para enviar el correo y mostrar un mensaje
   * de success o error dependiendo del resultado.
   *
   * @returns {Promise<void>}
   */

  const handleShowModal = (id) => {
    setActiveRoomId(id); // Guarda el ID de la habitación activa
    setShowModal(true); // Muestra el modal
  };

  const handleCloseModal = () => {
    setShowModal(false); // Oculta el modal
    setActiveRoomId(null); // Limpia el ID activo
  };

  const construirRequest = () => {
    // Extraemos los parámetros de la URL
    const checkInDate = queryParams.in;
    const checkOutDate = queryParams.out;
    const id = queryParams.idHotel; // ID del destino
    const tipo = queryParams.t || "alojamiento"; // Tipo de alojamiento
    setSelectedDates([checkInDate, checkOutDate]);
    // Crear habitaciones a partir de los parámetros pax
    const habitaciones = Object.keys(queryParams)
      .filter((key) => key.startsWith("pax")) // Filtramos las claves que empiezan con 'pax'
      .map((key) => {
        const [adultos, menores, edades] = queryParams[key].split("|");
        return {
          num_adultos: parseInt(adultos, 10),
          num_menores: parseInt(menores, 10),
          edad_menores: edades ? edades.replace(/,/g, "|") : "", // Convertimos comas en pipes
        };
      });

    const habitacionesFormatted = Object.keys(queryParams)
      .filter((key) => key.startsWith("pax")) // Filtramos las claves que empiezan con 'pax'
      .map((key, index) => {
        const [adultos, menores, edades] = queryParams[key].split("|");

        // Convertir edades (si las hay) en un array
        const edadesArray =
          edades === "0" || !edades ? [] : edades.split(",").map(Number);

        // Devolver el objeto con la estructura requerida
        return {
          room: index + 1, // El número de la habitación es el índice + 1
          adults: parseInt(adultos, 10),
          minors: parseInt(menores, 10),
          ages: edadesArray,
        };
      });

    setRooms(habitacionesFormatted);
    setTotalRooms(habitaciones);
    // Construir el objeto final
    const request = {
      fechas: {
        checkin: checkInDate,
        checkout: checkOutDate,
      },
      alojamiento: {
        id: id,
        tipo: tipo,
      },
      habitaciones,
    };

    return request;
  };

  useEffect(() => {
    requestData = construirRequest(); // Esto solo se ejecuta cuando `location.search` cambia
  }, [location.search]);

  useEffect(() => {
    // Obtener la URL actual
    const queryParams = parseQueryParams(location.search);

    // Obtener las fechas de entrada y salida de la URL
    const checkInDate = queryParams.in;
    const checkOutDate = queryParams.out;

    if (checkInDate && checkOutDate) {
      const checkIn = new Date(checkInDate);
      const checkOut = new Date(checkOutDate);
      const timeDifference = checkOut - checkIn;
      const totalNights = timeDifference / (1000 * 3600 * 24);

      setNights(totalNights);
    }

    const dataNight = [checkInDate, checkOutDate];

    setTimeNights(dataNight);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const fetchElemento = async () => {
      try {
        const response = await elementoPorSeccion(idElemento);

        const formattedImages = response[1].imagenes.map((img) => ({
          image: img.url,
          texto: img.texto,
        }));

        setImgsBanners(formattedImages);
      } catch (err) {
        console.error("Error al cargar las imágenes:", err);
      }
    };

    fetchElemento();
  }, [idElemento]);

  const fetchHotels = async () => {
    try {
      const response = await getHotels(requestData);
      return response;
    } catch (error) {
      console.error("Error fetching hotels:", error);
      return [];
    }
  };

  const fetchRates = async () => {
    try {
      const response = await getHotelAvailability(requestData);
      return response;
    } catch (error) {
      console.error("Error fetching rates:", error);
      return [];
    }
  };

  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      try {
        const hotelsData = await fetchHotels();
        const ratesData = await fetchRates();
        setNameDestination(hotelsData[0].destino);

        setHotels(hotelsData);
        setRates(ratesData);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.error("Error fetching data:", error);
      }
    };

    fetchData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search]);

  const getStarCount = (categoria) => {
    const starMatch = categoria.match(/^(\d+)/); // Busca el número al inicio de la cadena
    return starMatch ? parseInt(starMatch[1], 10) : 0; // Devuelve el número de estrellas
  };

  const HotelStars = ({ categoria }) => {
    const starCount = getStarCount(categoria); // Obtener el número de estrellas

    // Crear un arreglo de estrellas para renderizar
    const stars = Array.from({ length: starCount }, (_, index) => (
      <IoStarSharp key={index} className="star-icon" />
    ));

    return <div className="section-stars">{stars}</div>;
  };

  const actualizarDatos = (
    arrData,
    dataName,
    dataNameHotel,
    dataDestino,
    dates,
    pax,
    dataApi,
    dataCategoria,
    dataId,
    dataMoneda,
    dataIdHab,
    dataCodePais,
    imgHab,
    nights,
    numHabitaciones,
    politicasCancelacion,
    urlHotel,
    totalPrices // Cantidad de habitaciones a agregar
  ) => {
    const datosPrevios = JSON.parse(sessionStorage.getItem("datosReserva")) || {
      hospedaje: [],
    };

    // Obtener la cantidad total de habitaciones que el usuario buscó
    const totalRoomsBuscadas = rooms.length; // Sumamos todas las habitaciones del array rooms

    // Contar cuántas habitaciones de este hotel ya están en sessionStorage
    const habitacionesExistentes = datosPrevios.hospedaje.filter(
      (hab) => hab.id_atv3 === dataId
    ).length;
    const nuevasHabitaciones = Array.from({ length: numHabitaciones }, () => ({
      nombre: dataNameHotel,
      destino: dataDestino,
      nombreHab: dataName,
      checkIn: dates[0],
      checkOut: dates[1],
      paxes: pax,
      api: dataApi,
      categoria: dataCategoria,
      id_atv3: dataId,
      moneda: dataMoneda,
      idHab: dataIdHab,
      codigoPais: dataCodePais,
      imgHab: imgHab,
      noches: nights,
      totalPrices: totalPrices,
      adultos: arrData.adults,
      menores: arrData.children,
      edades: pax[0].ages.join(",") != "" ? pax[0].ages.join(",") : "0",
      nombrePlan: arrData.boardName,
      net: arrData.net,
      cancellationPoliciesText: politicasCancelacion,
      ...arrData,
    }));
    const nuevasUrl = Array.from({ length: numHabitaciones }, () => ({
      urlHotel: urlHotel,
    }));
    // Validar que no se agreguen más habitaciones de las buscadas
    if (habitacionesExistentes + numHabitaciones > totalRoomsBuscadas) {
      Swal.fire({
        title: "Máximo de habitaciones solicitadas",
        text: "Haz agregado el máximo de habitaciones solicitadas.",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: "Continuar con la reservación",
        cancelButtonText: "Cancelar esta habitación",
        denyButtonText: "Reemplazar habitación",
        customClass: {
          confirmButton: "bg-primary w-auto",
          denyButton: "btn-danger w-auto",
        },
        preConfirm: () => {
          window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
        },
      }).then((result) => {
        if (result.isConfirmed) {
          // Continuar con la reservación
          navigate("/preventa");
        } else if (result.isDenied) {
          // Crear una copia del array actual
          let nuevoHospedaje = [...datosPrevios.hospedaje];

          // Reemplazar la última habitación con la nueva
          nuevoHospedaje[nuevoHospedaje.length - 1] = Array.isArray(
            nuevasHabitaciones
          )
            ? nuevasHabitaciones[0] // Extrae el primer objeto si es un array
            : nuevasHabitaciones;

          // Guardar en sessionStorage
          const setDatos = {
            idPasarela: pdp?.nombre,
            hospedaje: nuevoHospedaje,
            url: [...nuevasUrl],
          };

          // const setUrl = {
          //   url: [...nuevasUrl],
          // }

          sessionStorage.setItem("datosReserva", JSON.stringify(setDatos));
          sessionStorage.setItem("datosURL", JSON.stringify(setDatos.url));

          // Actualizar el estado global en React
          setShowAlert(true);
          setArrSession(setDatos);
        }
      });
      return;
    } else {
      // Crear un array de habitaciones a agregar

      // Agregar nuevas habitaciones correctamente
      const nuevoHospedaje = [...datosPrevios.hospedaje, ...nuevasHabitaciones];

      // Guardar en sessionStorage
      const setDatos = {
        idPasarela: pdp?.nombre,
        hospedaje: nuevoHospedaje,
        url: [...nuevasUrl],
      };

      sessionStorage.setItem("datosReserva", JSON.stringify(setDatos));
      sessionStorage.setItem("datosURL", JSON.stringify(setDatos.url));

      // Actualizar el estado global en React
      setShowAlert(true);
      setArrSession(setDatos);
    }
  };

  return (
    <>
      {loading && <Loader />}
      <div className="hotel">
        <div className="section-photos container pt-5 pb-5">
          {hotels?.map((hotel, index) => (
            <Row key={index + 1}>
              <Col lg={12} className="pb-4 text-start">
                <h1 className="titulo-hotel">{hotel.nombre}</h1>
                <div className="section-stars d-flex">
                  {rates?.length > 0 ? (
                    rates?.[0]?.categoria === "BOU" ? (
                      <h4>{rates?.[0]?.categoria}</h4>
                    ) : (
                      <HotelStars categoria={rates?.[0]?.categoria} />
                    )
                  ) : (
                    <></>
                  )}
                  <span
                    className="text-md mt-1 mx-5"
                    style={{ fontSize: "15px" }}
                  >
                    {hotel?.direccion}
                  </span>
                </div>
              </Col>
              <Col lg={8}>
                <Tabs defaultActiveKey="gallery" className="mb-3 gallery-hotel">
                  <Tab eventKey="gallery" title="Galería">
                    <div className="slider-container">
                      <Swiper
                        style={{
                          "--swiper-navigation-color": "#fff",
                          "--swiper-pagination-color": "#fff",
                        }}
                        spaceBetween={30}
                        autoplay={{
                          delay: 3000,
                          disableOnInteraction: false,
                        }}
                        loop={true}
                        navigation={true}
                        thumbs={{ swiper: thumbsSwiper }}
                        modules={[Autoplay, FreeMode, Navigation, Thumbs]}
                        className="mySwiper2"
                      >
                        {hotel?.imagenes?.map((hotelImg, indexImg) => (
                          <SwiperSlide key={indexImg}>
                            <img
                              src={`http://photos.hotelbeds.com/giata/bigger/${hotelImg?.url}`}
                              alt={`Imagen ${indexImg + 1}`}
                              style={{
                                width: "100%",
                                height: "620px",
                                marginBottom: "15px",
                              }}
                            />
                          </SwiperSlide>
                        ))}
                      </Swiper>
                      <Swiper
                        onSwiper={setThumbsSwiper}
                        spaceBetween={0}
                        slidesPerView={4}
                        freeMode={true}
                        watchSlidesProgress={true}
                        modules={[FreeMode, Navigation, Thumbs]}
                        className="mySwiper"
                      >
                        {hotel?.imagenes?.map((hotelImg, indexImg) => (
                          <SwiperSlide key={indexImg}>
                            <img
                              src={`http://photos.hotelbeds.com/giata/bigger/${hotelImg?.url}`}
                              alt={`Imagen ${indexImg + 1}`}
                              style={{
                                width: "70%",
                                height: "80px",
                                marginBottom: "15px",
                                objectFit: "cover",
                              }}
                            />
                          </SwiperSlide>
                        ))}
                      </Swiper>
                    </div>
                  </Tab>
                  <Tab eventKey="map" title="Mapa">
                    <iframe
                      title="Mapa del hotel"
                      src={`https://www.google.com/maps/embed/v1/place?key=AIzaSyCPH50UmrLwDaIBrtOsq2Kig6xR_cHl1dw&q=${hotel?.latitud},${hotel?.longitud}&zoom=15`}
                      allowFullScreen
                      style={{ width: "100%", height: "720px" }}
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                    ></iframe>
                  </Tab>
                  <Tab eventKey="streetview" title="Streetview">
                    <iframe
                      title="Streetview del hotel"
                      src={`https://www.google.com/maps/embed/v1/streetview?key=AIzaSyCPH50UmrLwDaIBrtOsq2Kig6xR_cHl1dw&location=${hotel?.latitud},${hotel?.longitud}`}
                      allowFullScreen
                      style={{ width: "100%", height: "720px" }}
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                    ></iframe>
                  </Tab>
                </Tabs>
              </Col>
              <Col lg={4}>
                <img
                  src={seguroViajero}
                  className="pt-4 mt-5 pb-3"
                  style={{ height: "54rem" }}
                  alt="banner seguro viajero"
                />
                {queryParams.idHotel && (
                  <SearchEngine
                    isModify={true}
                    modifyHotel={"hotel"}
                    hotelId={queryParams.idHotel}
                    hideDestinations={true}
                    showDestinations={hideSearchDestination}
                    setShowDestinatios={setHideSearchDestination}
                    selectedDates={selectedDates}
                    showPaxSelection={hidePaxSelection}
                    setShowPaxSelection={setHidePaxSelection}
                    totalRooms={totalRooms}
                    destination={nameDestination}
                    arrayRooms={rooms}
                  />
                )}
              </Col>
            </Row>
          ))}
        </div>
        {rates.length > 0 ? (
          <div className="section-availables-rooms container text-start">
            <h1 className="title-blue">Habitaciones disponibles</h1>
            <h4 className="text-secondary pb-5">
              Contrata tu habitación en paquete o en forma individual
            </h4>

            {rates?.map((ratesHabs, index) => (
              <div className="pb-5" key={index + 1}>
                {ratesHabs?.habitaciones?.map((rateHab, indexhab) => (
                  <Card className="shadow-box mt-2" key={indexhab + 1}>
                    <Row>
                      <Col lg={3}>
                        {hotels?.map((hotel) => {
                          img = hotel?.imagenes?.find(
                            (hotelHab) =>
                              hotelHab?.id_tipo_foto == 2 &&
                              hotelHab?.tipo_habitacion == rateHab?.code
                          )
                            ? `http://photos.hotelbeds.com/giata/bigger/${
                                hotel.imagenes?.find(
                                  (hotelHab) =>
                                    hotelHab?.id_tipo_foto == 2 &&
                                    hotelHab?.tipo_habitacion == rateHab?.code
                                )?.url
                              }`
                            : `http://photos.hotelbeds.com/giata/bigger/${hotel?.imagenes?.[0]?.url}`;
                          return (
                            <div key={hotel?.id + 1}>
                              <img
                                src={img ? img : imgPreview}
                                className="hotel-img"
                                alt="image-destinations"
                                style={{
                                  width: "100%",
                                  height: "300px",
                                  objectFit: "cover",
                                }}
                              />
                            </div>
                          );
                        })}
                      </Col>
                      <Col lg={9}>
                        {rateHab?.rates?.map((rate, indexRate) => {
                          let politicasText = "";
                          rate?.cancellationPolicies?.forEach((policy) => {
                            politicasText += `<strong>Fecha de cancelación:</strong> ${FormatCancellationPolicies(
                              policy?.from
                            )} <br/>
                                            <strong>Monto de penalidad:</strong> ${Currency(
                                              policy?.amount
                                            )} <br/><br/>`;
                          });
                          return (
                            <Row
                              key={indexRate + 1}
                              className="border-bottom m-3"
                            >
                              <Col lg={5}>
                                <div className="detail-hotel pt-3 p-3">
                                  <span className="name-hotel text-secondary">
                                    {rateHab?.name}
                                  </span>
                                  <br />
                                  <span className="font-select-room text-secondary">
                                    {rate?.rooms} Habitación para:
                                  </span>
                                  <br />
                                  <br />
                                  <span
                                    className="font-select-room text-danger pt-5"
                                    style={{ fontWeight: "500" }}
                                  >
                                    <FaMale />
                                    {rate?.adults}{" "}
                                    {rate?.adults > 1
                                      ? " Adultos "
                                      : " Adulto "}
                                  </span>

                                  <span
                                    className="font-select-room text-danger px-3"
                                    style={{ fontWeight: "500" }}
                                  >
                                    <FaChild />
                                    {rate?.children}
                                    {rate?.children > 0 ? (
                                      <span>
                                        {rate?.children > 1
                                          ? " niños "
                                          : " niño "}
                                        de {rate?.childrenAges}
                                      </span>
                                    ) : (
                                      ""
                                    )}
                                  </span>
                                </div>
                                <div className="section-nights p-3">
                                  <span
                                    className="font-select-room"
                                    style={{ fontWeight: "500" }}
                                  >
                                    {rate.rateClass === "NRF" ? (
                                      <span className="text-danger">
                                        <MdOutlineCancel color="red" /> No
                                        Reembolsable
                                      </span>
                                    ) : (
                                      <span className="text-success">
                                        <FaCheck color="green" /> Reembolsable
                                      </span>
                                    )}
                                  </span>
                                </div>
                                <div className="section-nights  text-secondary p-3">
                                  {rate.cancellationPolicies && (
                                    <span className="font-select-room">
                                      <FaRegCheckCircle /> A partir del{" "}
                                      <strong
                                        style={{ textDecoration: "underline" }}
                                      >
                                        {FormatDate(
                                          rate?.cancellationPolicies?.[0]?.from
                                        ) + " 11:59 PM"}
                                      </strong>
                                      , será aplicada una penalidad por
                                      cancelación por la cantidad de{" "}
                                      <strong>
                                        {Currency(
                                          rate?.cancellationPolicies?.[0]
                                            ?.amount
                                        ) + " MXN"}
                                      </strong>
                                      .
                                    </span>
                                  )}
                                </div>
                              </Col>
                              <Col lg={3}>
                                <div className="section-meal pt-4 p-3">
                                  <span className="meal text-secondary">
                                    Plan de alimentos: {rate?.boardName}
                                  </span>
                                  <div>
                                    <Row className="container">
                                      <Col
                                        className="d-flex justify-content-end"
                                        style={{ paddingTop: "5px" }}
                                      >
                                        <Button
                                          onClick={() =>
                                            handleShowModal(rateHab?.code)
                                          }
                                          id={rateHab?.code}
                                          className="badge-all-inclusive bg-primary p-2"
                                        >
                                          Detalle de la habitación
                                        </Button>
                                        <br />
                                      </Col>

                                      <Col
                                        className="d-flex justify-content-end"
                                        style={{ paddingTop: "5px" }}
                                      >
                                        <br />
                                      </Col>
                                    </Row>
                                  </div>
                                </div>
                              </Col>
                              <Col
                                lg={4}
                                className="hotel_img d-flex justify-content-around"
                              >
                                <div className="text-secondary font-select-room text-end p-3">
                                  <div className="section-nights pt-4 pb-4">
                                    <span className="font-select-room">
                                      {nights} {nights > 1 ? "noches" : "noche"}
                                      , {rate?.adults + rate?.children}{" "}
                                      {rate?.adults + rate?.children > 1
                                        ? "personas"
                                        : "persona"}
                                    </span>
                                  </div>
                                  <div>
                                    <span className="location-hotel text-danger">
                                      Precio total{" "}
                                      {Currency(
                                        totalPrices(
                                          rate?.net,
                                          nights,
                                          markup
                                        )[1]
                                      ) + " MXN"}
                                    </span>
                                    <br />
                                    <span className="font-select-room">
                                      Precio por noche:{" "}
                                      {Currency(
                                        totalPrices(
                                          rate?.net,
                                          nights,
                                          markup
                                        )[0]
                                      ) + " MXN"}
                                    </span>
                                    <br />
                                    <p>Impuestos incluidos*</p>
                                  </div>

                                  <Col
                                    style={{
                                      paddingTop: "5px",
                                      paddingBottom: "5px",
                                    }}
                                  >
                                    <Button
                                      type="submit"
                                      onClick={(e) =>
                                        actualizarDatos(
                                          rate,
                                          rateHab?.name,
                                          ratesHabs?.nombre,
                                          ratesHabs?.destino,
                                          timeNights,
                                          rooms,
                                          ratesHabs?.api,
                                          ratesHabs?.categoria,
                                          hotels?.[0]?.id_atv3,
                                          ratesHabs?.moneda,
                                          rateHab?.code,
                                          hotels?.[0]?.codigo_pais,
                                          img,
                                          nights,
                                          1, //num de habs,
                                          politicasText,
                                          arrSessionUrl,
                                          totalPrices(
                                            rate?.net,
                                            nights,
                                            markup
                                          )[1]
                                        )
                                      }
                                      className="btn-select-room bg-primary p-2 text-center"
                                      style={{
                                        fontSize: "14px",
                                        height: "35px",
                                      }}
                                    >
                                      Seleccionar habitación
                                    </Button>
                                  </Col>
                                </div>
                              </Col>
                            </Row>
                          );
                        })}
                      </Col>
                    </Row>
                  </Card>
                ))}
              </div>
            ))}

            <div className="section-info-hotel container pb-5">
              <Row>
                <div className="text-center">
                  <h1 className="title-blue">Conoce más sobre este hotel</h1>
                  <h4 className="text-secondary pb-5">
                    <strong>International Travel Net</strong> siempre en tus
                    viajes
                  </h4>
                </div>
                {hotels?.map((hotelDesc, indexDesc) => (
                  <Col lg={12} key={indexDesc} className="tabs-info-hotel">
                    <Tabs
                      className="mb-3 gallery-hotel"
                      style={{
                        padding: "15px",
                        border: "1px solid rgba(13, 21, 75, 0.15)",
                      }}
                    >
                      <Tab eventKey="tripadvisor" title="TRIPADVISOR">
                        <div style={{ width: "100%", height: "100%" }}>
                          <iframe
                            title="tripadvisor"
                            style={{ width: "100%", height: "600px" }}
                            id="trip-ad"
                            src={`https://www.tripadvisor.com/WidgetEmbed-cdspropertydetail?display=true&partnerId=6CA95E2409844D6183003CEFCDDC2BDE&lang=es&locationId=${hotelDesc?.id_bol}`}
                          ></iframe>
                        </div>
                      </Tab>

                      <Tab eventKey="amenities" title="AMENIDADES">
                        <Row>
                          <Col lg={4}>
                            <ul>
                              {hotelDesc?.servicios
                                ?.slice(0, 31)
                                ?.map((servicio, index) => (
                                  <li style={{ fontSize: "16px" }} key={index}>
                                    {servicio?.servicio}
                                  </li>
                                ))}
                            </ul>
                          </Col>
                          <Col lg={4}>
                            <ul>
                              {hotelDesc?.servicios
                                ?.slice(31, 62)
                                ?.map((servicio, index) => (
                                  <li style={{ fontSize: "16px" }} key={index}>
                                    {servicio?.servicio}
                                  </li>
                                ))}
                            </ul>
                          </Col>
                          <Col lg={4}>
                            <ul>
                              {hotelDesc?.servicios
                                ?.slice(62)
                                ?.map((servicio, index) => (
                                  <li style={{ fontSize: "16px" }} key={index}>
                                    {servicio?.servicio}
                                  </li>
                                ))}
                            </ul>
                          </Col>
                        </Row>
                      </Tab>

                      <Tab eventKey="description" title="DESCRIPCIÓN">
                        <p style={{ fontSize: "15px" }}>
                          {hotelDesc?.descripcion}
                        </p>
                      </Tab>
                    </Tabs>
                  </Col>
                ))}
              </Row>
            </div>
          </div>
        ) : (
          <div className="text-center">
            <h1 className="title-blue" style={{ fontSize: "45px" }}>
              No hay habitaciones disponibles
            </h1>
          </div>
        )}
      </div>
      <div className="py-5 container">
        <div className="text-center mb-5">
          <h1 className="section-title outline">Otros Destinos Similares</h1>
        </div>
        <div className="carousel-container">
          <Swiper
            spaceBetween={5}
            slidesPerView={1}
            loop={true}
            autoplay={{ delay: 3000 }}
            breakpoints={{
              640: {
                slidesPerView: 1,
              },
              768: {
                slidesPerView: 2,
              },
              1024: {
                slidesPerView: 3.7,
              },
            }}
          >
            {imgsBanners?.map((image, index) => (
              <SwiperSlide key={index}>
                <Link
                  to={`/alojamientos?t=destino&id=${image.texto}&in=${checkIn}&out=${checkOut}&hab=1&pax1=2|0|0`}
                >
                  <img
                    src={`https://panel.internationaltravelnet.com.mx/assets/uploads/elementos/${image.image}`}
                    alt={`Imagen ${index + 1}`}
                    style={{ width: "100%", height: "450px" }}
                  />
                </Link>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
      <div className="py-5">
        <div className="w-100 position-relative">
          <img className="w-100" src={bannerContacto} alt="" />
          <a
            href="tel:+7772035097"
            style={{
              top: "80%",
              position: "absolute",
              left: "28%",
              fontSize: "1.3vw",
              background: "#fff",
              color: "#ff0000",
              border: "none",
              padding: "0.8rem",
              width: "19%",
              textAlign: "center",
              borderRadius: "1rem",
            }}
            onMouseEnter={() => setButtonText("777 179 0074")}
            onMouseLeave={() => setButtonText("Contácta con tu asesor")}
          >
            {buttonText}
          </a>
        </div>
      </div>
      {showModal && (
        <ModalHabs
          title={"Detalles de la habitación"}
          handleClose={handleCloseModal}
          handleShow={handleShowModal}
        >
          {rates?.map((ratesHabs) => (
            <div>
              {ratesHabs?.habitaciones
                ?.filter((rateHab) => rateHab?.code === activeRoomId) // Filtrar por ID activo
                ?.map((hab) => (
                  <div>
                    <div>
                      <Col className="shadow p-3 border">
                        <span className="fs-3">
                          <IoCalendarNumberOutline /> Precio de la habitación
                          del {timeNights[0]} al {timeNights[1]}
                        </span>
                      </Col>

                      <Col className="shadow p-3 border mt-2">
                        <span className="fs-3">
                          <AiOutlineDollar /> Precio por noche:{" "}
                          {Currency(
                            totalPrices(hab.rates[0].net, nights, markup)[0]
                          ) + " MXN"}
                        </span>
                      </Col>
                      <Col className="shadow p-3 border mt-2">
                        <span className="fs-3">
                          <FaMale /> Adultos: {hab.rates[0].adults} /{" "}
                          <FaChild /> Niños: {hab.rates[0].children} /{" "}
                          <FaChildren /> Edades:{" "}
                          {hab.rates[0].children > 0
                            ? hab.rates[0].childrenAges
                            : "N/A"}
                        </span>
                      </Col>
                      <Col className="shadow p-3 border mt-2">
                        <span className="fs-3">
                          <MdOutlineFastfood /> Plan de alimento:{" "}
                          {hab.rates[0].boardName}
                        </span>
                      </Col>
                    </div>

                    <div className="section-nights  text-secondary p-3">
                      {hab.rates[0].cancellationPolicies && (
                        <span className="font-select-room">
                          <FaRegCheckCircle /> A partir del{" "}
                          {FormatDate(
                            hab.rates[0].cancellationPolicies[0].from
                          ) + " 11:59 PM"}
                          , será aplicada una penalidad por cancelación por la
                          cantidad de{" "}
                          {Currency(
                            hab.rates[0].cancellationPolicies[0].amount
                          )}
                          .
                        </span>
                      )}
                    </div>
                  </div>
                ))}
            </div>
          ))}
        </ModalHabs>
      )}
      <CheckOutCart
        setAlert={setShowAlert}
        showAlert={showAlert}
        setAlertMessage={"Se agrego una nueva habitación"}
        arrDatos={arrSession}
      />
    </>
  );
};
